import React from "react";
import { Alert } from "reactstrap";

function AlertComponent({ type, message, onClose }) {
  return (
    <Alert
      className="mb-2"
      style={{ padding: 7 }}
      color={type}
      closeClassName="alert-close"
      isOpen={true}
      toggle={onClose}
    >
      <div className="alert-body">{message}</div>
    </Alert>
  );
}

export default AlertComponent;
